<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img"><img src="/assets/product/engine/6Z30/6Z30.jpg" alt=""></div>
      <div class="detail-banner-r">
        
        <div class="detail-banner-t2">6Z30 Twin Turbo V6 Engine</div>
        <div class="detail-banner-desc">
          China’s first independently developed twin turbo V6 engine.<br />
          Features a stable and efficient combustion system, GDI+PFI dual injection system, dual VGT turbochargers, a multi-function intake system, a high-strength crankshaft and connecting rod system, a duplex chain valve timing, the NVH development of vehicle, and precise control technologies.
        </div>
      </div>
    </div>

    <div class="detail-box">
      <div class="detail-title">Powerful Performance</div>
      <div class="detail-utils">
        <div class="detail-utils-item">
          <div class="detail-utils-d">Displacement (L)</div>
          <div class="detail-utils-u">2.993</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Max. Net Power (kW/rpm)</div>
          <div class="detail-utils-u">260/6000</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Max. Net Torque (Nm/rpm)</div>
          <div class="detail-utils-u">500/1500~4500</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Low-Speed Torque (Nm/rpm)</div>
          <div class="detail-utils-u">320/1000</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Emission Standards</div>
          <div class="detail-utils-u">China 6b, SULEV30, Euro 6d</div>
        </div>
      </div>
      <div class="detail-four-list">
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/6Z30/6Z30-1.jpg" alt=""></div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">GDI+PFI Dual-Fuel Injection System</div>
          <div class="detail-four-desc">
            Utilizes a combined Gasoline Direct Injection (GDI) and Port Fuel Injection (PFI) system for versatile fuel atomization across a broad operational range, reducing PN emissions by up to 90%. GDI injection pressure is 350 bar. PFI injection pressure is 5.5 bar.
          </div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">Dual VGT Turbochargers</div>
          <div class="detail-four-desc">
            Features newly developed VGT-specific scroll turbines, increasing flow rate by 12%.<br />
            With 980°C heat-resistant and S-shaped guide nozzle ring vanes, peak turbine efficiency reaches 73%.<br />
            Proprietary nonlinear VGT boost control logic with micro-correction models and nozzle ring self-cleaning functions maximize turbocharger potential.
          </div>
        </div>
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/6Z30/6Z30-2.jpg" alt=""></div>
        </div>
      </div>
    </div>
    <div class="detail-box detail-bottom-bgs">

      <div class="detail-updown-list">
        <div class="detail-updown-item">
          <div class="detail-updown-title">Multi-Function Intake System</div>
          <div class="detail-updown-desc">
            Dual electronic throttle bodies, an intake manifold-integrated water-cooled intercooler, and a dedicated intake silencer deconstruction. Compared to conventional designs, the intake tract length is reduced by 40%, pressure loss is decreased by 60%, and steady-state load response time at 1500 rpm is shortened by 0.6 seconds.<br />
            The integrated water-cooled intercooler lowers post-compressor air temperature from 170°C to below 50°C with 93% cooling efficiency.<br />
            Paired with variable-volume broadband resonance chambers, noise attenuation capability reaches ≥25 dB within the 1000-3000 Hz range.
          </div>
          <div class="img-box"><img src="/assets/product/engine/6Z30/6Z30-3.jpg" alt=""></div>
        </div>
        <div class="detail-updown-item">
          <div class="detail-updown-title">Duplex Chain Valve Timing</div>
          <div class="detail-updown-desc">
            A center-mounted OCV enables fully variable intake and exhaust camshaft timing (VVT).<br />
            Inner guide rail placement allows for a more compact design.<br />
            Utilizes an ultra-quiet toothed chain, staggered sprockets, and a pressure-maintaining tensioner.
          </div>
          <div class="img-box"><img src="/assets/product/engine/6Z30/6Z30-4.jpg" alt=""></div>
        </div>
      </div>
    </div>

  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
  nextTick(() => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container, index) => {
      const containerKey = `swiper_${index}`;
      container.dataset.swiperKey = containerKey;
      const swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        preventClicks: true,
        effect: 'fade',
      });
      swiperInstances.value[containerKey] = swiperInstance;
    });

    bindTabClickEvent();
  });
});
function bindTabClickEvent() {
  const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

  allSwiperLists.forEach((swiperList) => {
    const tabItems = swiperList.querySelectorAll('.detail-tab-item');
    const targetSwiperContainer = swiperList.querySelector('.swiper-container');

    if (!tabItems.length || !targetSwiperContainer) return;

    const containerKey = targetSwiperContainer.dataset.swiperKey;
    const targetSwiper = swiperInstances.value[containerKey];
    if (!targetSwiper) return;

    const handleTabAction = (tabItem, localTabIndex) => {
      tabItems.forEach(item => item.classList.remove('active'));
      tabItem.classList.add('active');
      targetSwiper.slideTo(localTabIndex, 300, true);
    };
    tabItems.forEach((tabItem, localTabIndex) => {
      const handleTabClickWrapper = () => {
        handleTabAction(tabItem, localTabIndex);
      };
      tabItem.removeEventListener('click', handleTabClickWrapper);
      tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
      tabItem.addEventListener('click', handleTabClickWrapper);
      tabItem.addEventListener('mouseenter', handleTabClickWrapper);
    });
  });
}
</script>

<script>
export const pageConfig = {
  title: '6Z30 Twin Turbo V6 Engine - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/engine/6Z30.html'

};

import { createApp } from 'vue';
import App from './6Z30.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./6Z30.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped></style>